import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form as FormComponent } from 'components/Form'
import { InputForm, TitleForm } from 'components/Form/components'
import { ApiErrors } from 'ui-components/ApiErrors'

export default function Form(props) {
  const {
    paymentPlan,
    onCancel,
    onSave,
    saving,
    responseError,
  } = props

  const [attributes, setAttributes] = useState()

  useEffect(() => {
    setAttributes(paymentPlan.attributes)
  }, [paymentPlan])

  const handleSave = () => {
    onSave(attributes)
  }

  const handleChange = (evt) => {
    const { name, value } = evt.target
    setAttributes({
      ...attributes,
      [name]: value,
    })
  }

  return attributes ? (
    <FormComponent
      onCancel={onCancel}
      onSave={handleSave}
      saving={saving}
    >
      <TitleForm>Plano de pagamento</TitleForm>
      <ApiErrors responseError={responseError} />
      <InputForm
        fullWidth
        label="Número da parcela"
        type="text"
        name="installment_number"
        value={attributes.installment_number}
        onChange={handleChange}
      />
      <InputForm
        fullWidth
        label="Descrição"
        type="text"
        name="description"
        value={attributes.description}
        onChange={handleChange}
      />
    </FormComponent>
  ) : null
}

Form.propTypes = {
  paymentPlan: PropTypes.objectOf(PropTypes.any),
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  responseError: PropTypes.objectOf(PropTypes.any),
}

Form.defaultProps = {
  paymentPlan: {},
  saving: false,
  responseError: {},
}
